import React from "react";
import { ProjectBox } from "./styles";
import { useNavigate } from "react-router-dom";

const ProjectCard = ({ name, thumb, id }) => {
	const navigate = useNavigate();
	return (
		<ProjectBox>
			<div className='img__container'>
				<img src={thumb} alt={name} />
			</div>
			<div className='project-name'>
				<h3>Project:</h3>
				<p>{name}</p>
			</div>
			<div className='btn__container'>
				<button
					onClick={() => {
						document.body.style.overflow = "hidden";
						navigate(`/projects/${id}`);
					}}
				>
					More...
				</button>
			</div>
		</ProjectBox>
	);
};

export default ProjectCard;
